The answers provided by the candidate.

For `SingleSelect` and `FreeText` this will be a single element array.
